<template>
    <section id="checkout-user-handler">
        <br><br>
        <div class="row">
            <div class="col-sm-6">
                <button class="btn btn-primary btn-shadow" type="button" @click="setMode('login')">Mit Kundenkonto kaufen</button>
            </div>
            <div class="col-sm-6">
                <button class="btn btn-primary btn-shadow" type="button" @click="setMode('guest')">Als Gast kaufen</button>                    
            </div>
        </div>

        <div class="row" v-if="mode == 'login'">
            <div class="col-sm-12">
                <login></login>    
                <br>        
                <button class="btn btn-primary" type="button" @click="login">Anmelden</button>
            </div>
            <div class="col-sm-6 col-sm-push-3">
                <button class="btn btn-dark btn-shadow" type="button" @click="setMode('register')">Registrieren</button>
            </div>
        </div>

        <div class="row" v-if="mode == 'register'">
            <register></register>
            <br>
            <button class="btn btn-primary" type="button" @click="register">Registrieren</button>
        </div>

        <div class="row" v-if="mode == 'guest'">
            <guest></guest>
            <br>
            <button class="btn btn-primary" type="button" @click="guest">Weiter</button>
        </div>

    </section>
</template>

<script>
export default {

    data() {
        return {
            mode: null
        }
    },

    methods: {

        setMode(mode) {
            this.mode = mode;
        },

        login() {
            App.event.fire('login.send');
        },

        register() {
            App.event.fire('registration.send');
        },

        guest() {
            App.event.fire('guest.send');
        }
    }
}
</script>